import { ACTION_RESULTS_PATH } from "../../framework/firebase/DBPathConstants";
import { GameIdFirebaseWrapper } from "../../framework/firebase/GameIdFirebaseWrapper";
import { Layer } from "../../framework/layer/Layer";
import { getPlayerIdFromTypedId } from "../../util/IdUtils";
export class ActionResultDeleter extends Layer {
    constructor(firebase, playerAndGameIdProvider) {
        super([]);
        this.gameIdFirebase = null;
        this.firebase = firebase;
        this.playerAndGameIdProvider = playerAndGameIdProvider;
    }
    deleteActionResult(actionId) {
        const resultRef = `${ACTION_RESULTS_PATH}/${getPlayerIdFromTypedId(actionId)}/${actionId}`;
        this.gameIdFirebase.remove(resultRef);
    }
    activate() {
        this.gameIdFirebase = new GameIdFirebaseWrapper(this.firebase, this.playerAndGameIdProvider.data.gameId);
    }
    close() {
    }
    getLayerData() {
        return null;
    }
    update(inEvent) {
        return null;
    }
}
//# sourceMappingURL=ActionResultDeleter.js.map